// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay-module__overlay___2eWlz","overlay-layer":"Overlay-module__overlay-layer___Kts9D","visible":"Overlay-module__visible___5BSrd"};